import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import {
  INFO_PATH,
  LIST_PATH,
  MODULE_PATH,
  USER_APPROVAL_PATH,
  USER_PATH,
} from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getUserApprovalsService = async () => {
  try {
    const result = await instance.get(USER_APPROVAL_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error as any
    throw new Error(e.response?.data)
  }
}

export const getUserApprovalsByUserService = async (id: any) => {
  try {
    const result = await instance.get(USER_APPROVAL_PATH + USER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    
    return undefined
  }
}

export const getUserInfoByUserIdService = async (id: any) => {
  try {
    const result = await instance.get(
      USER_PATH + MODULE_PATH + INFO_PATH + `/${id}`
    )
    return result.data
  } catch (error: any) {
    throw new Error(JSON.stringify(error))
  }
}

export const createUserApprovalService = async (userApproval: any) => {
  try {
    const result = await instance.post(USER_APPROVAL_PATH, userApproval)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error as any
    throw new Error(e.response?.data)
  }
}

export const deleteUserApprovalByUserIdService = async (id: any) => {
  try {
    const result = await instance.delete(
      USER_APPROVAL_PATH + USER_PATH + `/${id}`
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error as any
    throw new Error(e.response?.data)
  }
}
